module.exports = __webpack_public_path__ + "img/buy-btn-coupon1x.488cfde0.png";